//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class JobListModel extends ModelBase {
      static readonly $typeName = 'JobListModel';
      public key: string;
      public errorCount: number;
      public name: string;
      public status: string;
      public submittingEntityKey: string;
      public submittingEntityName: string;
      public successfulCount: number;
      public warningcount: number;
      public createdTimestamp: Date;
      public dataSetDisplayName: string;
      public dataSetTypeFullName: string;
      public rootEntitiesCount: number;
      public rootEntitiesProcessedCount: number;
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/JobListModel.ts